export function isEmbeddedDocument(): boolean {
  return window.top !== window.self;
}



// WEBPACK FOOTER //
// ./app/common/lib/util/browser.ts